import actions from '../actions';
import urls from '../urls';
import constants from '../constants';
import { checkHttpStatus, parseJSON, storeLocally, commonHeaders } from '../utils';

export function getUserApi(userData) {
    return new Promise((resolve, reject) => {
        const url =`${constants.BASE_API_URL}${urls.USERS}${userData.id}`;
        fetch(url, {
            method: "GET",
            headers: Object.assign({}, commonHeaders, {
                'Authorization': 'Bearer ' + userData.token
            })
        })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then((jsonResponse) => {
            //jsonResponse.token = userData.token;
            resolve(jsonResponse);
        })
        .catch(err => {
            console.error("There is an error getting user info!!", err);
            reject(err);
        });
    });
}

export function signInApi(user) {
    const url =`${constants.BASE_API_URL}${urls.USERS}login`;
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: "POST",
            headers: commonHeaders,
            body: JSON.stringify(user)
        })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then((jsonResponse) => {
            //jsonResponse.token = userData.token;
            resolve(jsonResponse);
        })
        .catch(err => {
            console.error("There is an error logging in!!", err);
            reject(err);
        });
    });
}


// WEBPACK FOOTER //
// ./src/apis/userApis.js